<script>
	import FormModal from "../../../../shared/modal/FormModal.svelte";
	import ChangePasswordForm from "../../../../../forms/ChangePasswordForm.js";
</script>

<FormModal form={ChangePasswordForm} />
